<template>
  <content-section
    :icon="svg_backpack()"
    title="Bagaglio a mano"
    :description="
      flight_offer.source === 'GDS'
        ? `Nei voli di linea il bagaglio a mano comprende un trolley. Il peso ammesso
      può variare in base alla compagnia aerea. Controlla le condizioni e le
      franchigie sul sito della compagnia.`
        : `Nei voli low cost il bagaglio a mano include una borsa di piccole
      dimensioni da posizionare sotto il sedile. Verifica le specifiche sul sito
      della compagnia aerea.`
    "
  />
</template>

<script>
import { backpack } from '@/components/svg/bags';
import ContentSection from '@/components/blocks/wrappers/content-section.vue';

export default {
  name: 'personal-bags-info',
  components: {
    'content-section': ContentSection,
  },
  props: {
    flight_offer: Object,
  },
  data() {
    return {
      svg_backpack: backpack,
    };
  },
};
</script>
